import { BasicModel } from '../basic/basic.model';
import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';

export class TypeCompModel extends BasicModel implements BasicWithLibelleModel {
    code: string;
    libelle: string;
}
